/**
 * Shared regex building blocks for locale-related patterns.
 *
 * Country codes in the URL can be either a standard 2-letter ISO code (e.g. "de", "at")
 * or the special identifier "global".
 *
 * Usage examples:
 *   - Inline regex:  new RegExp(`^${COUNTRY_CODE_PATTERN}-[a-z]{2}$`, 'i')
 *   - Pre-built:     LOCALE_PREFIX_REGEX.test('global-en')  // true
 */

/**
 * Regex fragment (non-capturing group) that matches a country identifier.
 * "global" must come before [a-z]{2} so the regex engine does not greedily
 * consume the first two letters of "global" as a 2-letter code (e.g. "gl").
 */
export const COUNTRY_CODE_PATTERN = '(?:global|[a-z]{2})';

/** Matches a full `{country}-{language}` locale prefix (anchored, case-insensitive). */
export const LOCALE_PREFIX_REGEX = /^(?:global|[a-z]{2})-[a-z]{2}$/i;
